/* tslint:disable */
/* eslint-disable */
/**
 * e-SNRWB
 * Opis api e-SNRWB
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CreateUpdateProductTypeDto,
    CreateUpdateProductTypeDtoFromJSON,
    CreateUpdateProductTypeDtoFromJSONTyped,
    CreateUpdateProductTypeDtoToJSON,
} from './';

/**
 * 
 * @export
 * @interface CreateWithNewProductTypeParams
 */
export interface CreateWithNewProductTypeParams {
    /**
     * 
     * @type {string}
     * @memberof CreateWithNewProductTypeParams
     */
    inspectionId: string;
    /**
     * 
     * @type {CreateUpdateProductTypeDto}
     * @memberof CreateWithNewProductTypeParams
     */
    productType: CreateUpdateProductTypeDto;
}

export function CreateWithNewProductTypeParamsFromJSON(json: any): CreateWithNewProductTypeParams {
    return CreateWithNewProductTypeParamsFromJSONTyped(json, false);
}

export function CreateWithNewProductTypeParamsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateWithNewProductTypeParams {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'inspectionId': json['inspectionId'],
        'productType': CreateUpdateProductTypeDtoFromJSON(json['productType']),
    };
}

export function CreateWithNewProductTypeParamsToJSON(value?: CreateWithNewProductTypeParams | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'inspectionId': value.inspectionId,
        'productType': CreateUpdateProductTypeDtoToJSON(value.productType),
    };
}


